import React,{useState,useEffect} from "react";
import { NavLink, useParams } from "react-router-dom";
import "../Styles/CloudProMenu.css";
import panelVersions from "../Config/panelVersions.json";
export default function CloudProMenu() {
  const { mdId } = useParams();
// const selectedProject1 = JSON.parse(localStorage.getItem("selectedProject"));

// alert("-------selectedProject1---" + selectedProject1?.name);
 const [panelVersion1, setPanelVersion1] = useState("");
useEffect(() => {
  const storedVersion = sessionStorage.getItem("panelVersion1");

  if (storedVersion) {
    setPanelVersion1(storedVersion);
  } else if (panelVersions.length > 0) {
    setPanelVersion1(panelVersions[0]);
  }
}, [panelVersions]);
  const handleVersionChange = (e) => {
    const version = e.target.value;
    setPanelVersion1(version);
    sessionStorage.setItem("panelVersion1", version);
  };

  return (
    <div className="horizontal-menu">
      <NavLink
        to={`/${mdId}/layout/cloudproprojectconfig`}
        className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}
      >
        Projects
      </NavLink>

     

      <NavLink
        to={`/${mdId}/layout/cloudpropanelconfig`}
        className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}
      >
        Panel Network
      </NavLink>
       <NavLink
      to={`/${mdId}/layout/cloudprocauseeffect`}
        className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}
      >
        Cause-effect-matrix
      </NavLink>
       <NavLink
      to={`/${mdId}/layout/cloudproconfiguation`}
        className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}
      >
        Configuration
      </NavLink>
        <div className="version-selector">
        <label>Panel Version:</label>
        <select value={panelVersion1} onChange={handleVersionChange}>
            <option value="">--Select--</option>
          {panelVersions.map((v) => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}